
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_45719","data-name":"Group 45719","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 240 240"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"id":"Rectangle_15495","data-name":"Rectangle 15495","width":"240","height":"240","fill":"none"}}),_c('g',{attrs:{"id":"Group_45684","data-name":"Group 45684"}},[_c('rect',{attrs:{"id":"Rectangle_15488","data-name":"Rectangle 15488","width":"240","height":"240","fill":"none"}}),_c('g',{attrs:{"id":"Group_45683","data-name":"Group 45683","transform":"translate(33.555 1.366)"}},[_c('path',{attrs:{"id":"Path_29916","data-name":"Path 29916","d":"M84.025 185.059l.088 40.949-43.508-1.235 3.706-55.158-8.322-.379a65.57 65.57 0 0029.583 124.081h5.606a65.563 65.563 0 0065.555-65.57v-51.514c-8.887 4.5-21.059 5.03-31.7 5.031z","transform":"translate(0 -55.85)","fill":"#1ccdfd"}}),_c('path',{attrs:{"id":"Path_29917","data-name":"Path 29917","d":"M190.435 65.567A65.562 65.562 0 00124.878 0h-5.606a65.562 65.562 0 00-65.555 65.569v47.816C57.042 121 57.042 121 67.687 121l39.184-2.648 10.237-.088 13.5.469 23.849 5.347a65.558 65.558 0 0035.975-58.514","transform":"translate(-17.728)","fill":"#c458fb"}}),_c('path',{attrs:{"id":"Path_29918","data-name":"Path 29918","d":"M104.433 96.664v41.578H83.3a65.268 65.268 0 00-29.582 7.043V204.6h50.026v-41.575h21.135a65.289 65.289 0 0029.582-7.044V96.664z","transform":"translate(-17.728 -31.902)","fill":"#854cf9"}})])])])
          )
        }
      }
    